// import { jsPDF } from "jspdf";
// import banner1 from "../../../Assets/ptags/banner.jpg"

// export const generatePDF = () => {
//   const width = 1632;
//   const height = 1056;

//   const doc = new jsPDF({
//     orientation: 'landscape',
//     unit: 'pt',
//     format: [width, height],
//   });

//   // Optional background
//   doc.setFillColor(240);
//   doc.rect(0, 0, width, height, 'F');

//   // Set dashed line: [dash length, gap length]
//   doc.setLineDashPattern([10, 5], 0);
//   doc.setDrawColor(0); // black
//   doc.setLineWidth(1);

//   // Draw horizontal dashed line
//   doc.line(0, height / 2, width, height / 2);

//   // Draw vertical dashed line
//   doc.line(width / 2, 0, width / 2, height);


//   const bannerImgWidth = (width/2)-5;
//   const bannerImgHeight = 100;

//   //doc.addImage(banner1, 'JPEG', distance from x, distance from y, image width, image height);
//   doc.addImage(banner1, 'JPEG', 2.5, 0, bannerImgWidth, bannerImgHeight);
//   doc.addImage(banner1, 'JPEG', (width/2)+2.5, 0, bannerImgWidth, bannerImgHeight);
//   doc.addImage(banner1, 'JPEG', 2.5, (height/2)+2.5, bannerImgWidth, bannerImgHeight);
//   doc.addImage(banner1, 'JPEG', (width/2)+2.5, (height/2)+2.5, bannerImgWidth, bannerImgHeight);



//   // Save
//   doc.save('dashed-lines-pdf.pdf');
// };

// import { jsPDF } from "jspdf";
// import banner1 from "../../../Assets/ptags/banner.jpg";

// export const generatePDF = (sectionsCount) => {
//     const width = 1632;
//     const height = 1056;
//     const doc = new jsPDF({
//         orientation: "landscape",
//         unit: "pt",
//         format: [width, height],
//     });

//     const sectionWidth = width / 2;  // 1632 / 2 = 816 pt
//     const sectionHeight = height / 2; // 1056 / 2 = 528 pt


//     const bannerImgWidth = (width / 2) - 5;
//     const bannerImgHeight = 94;

//     const maxSectionsPerPage = 4; // 4 sections per page (2x2 grid per page)
//     let currentSection = 0;

//     // Loop through the sections and handle pages
//     while (currentSection < sectionsCount) {
//         // Add a new page if this isn't the first page
//         if (currentSection > 0) {
//             doc.addPage();
//         }

//         // Calculate number of sections on the current page
//         const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsCount - currentSection);

//         for (let i = 0; i < sectionsOnThisPage; i++) {
//             const sectionIndex = currentSection + i;
//             const xPos = (i % 2) * (width / 2) + 2.5;
//             const yPos = Math.floor(i / 2) * (height / 2) + 2.5;

//             if (sectionIndex < sectionsCount) {
//                 // Banner Image
//                 doc.addImage(banner1, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

//                 // Main Rectangle
//                 const sectionRectX = xPos + 2.5;
//                 const sectionRectY = yPos + bannerImgHeight + 4.8;
//                 const sectionRectWidth = sectionWidth / 2.9;
//                 const sectionRectHeight = sectionHeight - (bannerImgHeight + 12);

//                 doc.setLineWidth(2);
//                 doc.setDrawColor(71, 74, 119);


//                 const sectionMainImageX = xPos + sectionRectWidth +2.5;
//                 const sectionMainImageWidth = sectionWidth - (sectionRectWidth+2.5) ;
//                 const sectionMainImageHeight = 290;



//                 // main product image
//                 doc.addImage("https://fdapi.thefurnituredepots.com/uploads/media/Products/1739271656036_692_MSLS-Img-1.jpg", "JPEG", sectionMainImageX, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);




//                 doc.rect(sectionRectX, sectionRectY, sectionRectWidth, sectionRectHeight, 'S');

//                 // Horizontal divider inside main rectangle
//                 const lineY = sectionRectY + sectionRectHeight / 4;
//                 doc.setLineWidth(2);
//                 doc.line(
//                     sectionRectX,
//                     lineY,
//                     sectionRectX + sectionRectWidth,
//                     lineY
//                 );










//                 // === Left Rectangle with Grid ===
//                 const gridRectX = xPos + (sectionWidth / 1.49);
//                 const gridRectY = yPos + sectionHeight / 1.39 + 0.5;
//                 const gridRectW = sectionWidth / 3.1;
//                 const gridRectH = sectionHeight / 3.75;

//                 // Draw the left rectangle
//                 doc.setLineWidth(2);
//                 doc.rect(gridRectX, gridRectY, gridRectW, gridRectH, 'S');



//                 // Optional: another right rectangle (if still needed)
//                 const rightRectX = xPos + (sectionWidth / 2.83);
//                 const rightRectY = yPos + sectionHeight / 1.39 + 0.5;
//                 const rightRectW = sectionWidth / 3.2;
//                 const rightRectH = sectionHeight / 3.75;

//                 doc.setLineWidth(2);
//                 doc.rect(rightRectX, rightRectY, rightRectW, rightRectH, 'S');



//                 // Custom column widths (in percentage of total width)
//                 const col1 = rightRectW * 0.3;
//                 const col2 = rightRectW * 0.2;
//                 const col3 = rightRectW * 0.3;
//                 const col4 = rightRectW * 0.2;

//                 // Row height (still 4 rows)
//                 const rowHeight = rightRectH / 4;

//                 doc.setLineWidth(2);
//                 doc.setDrawColor(71, 74, 119); // Black

//                 // Draw 3 horizontal lines (4 rows)
//                 for (let r = 1; r < 4; r++) {
//                     const y = rightRectY + r * rowHeight;
//                     doc.line(rightRectX, y, rightRectX + rightRectW, y);
//                 }

//                 // Draw 3 vertical lines for custom-width columns
//                 const colX1 = rightRectX + col1;
//                 const colX2 = colX1 + col2;
//                 const colX3 = colX2 + col3;

//                 doc.line(colX1, rightRectY, colX1, rightRectY + rightRectH); // After col1
//                 doc.line(colX2, rightRectY, colX2, rightRectY + rightRectH); // After col2
//                 doc.line(colX3, rightRectY, colX3, rightRectY + rightRectH); // After col3












//             }
//         }


//         // Draw horizontal dashed line (same for every page)
//         doc.setLineDashPattern([10, 5], 0);
//         doc.setDrawColor(0); // black
//         doc.setLineWidth(1);
//         doc.line(0, height / 2, width, height / 2); // Horizontal line at half height

//         // Draw vertical dashed line (same for every page)
//         doc.line(width / 2, 0, width / 2, height); // Vertical line at half width

//         // Increment currentSection for the next page
//         currentSection += sectionsOnThisPage;
//     }

//     // Save the PDF
//     doc.save("dynamic-sections-with-lines.pdf");
// };

















// import { jsPDF } from "jspdf";
// import banner1 from "../../../Assets/ptags/banner.jpg";
// import { Url } from "../../../Services/Api";

// import "../../../Assets/ptags/fonts/Montserrat-Bold";
// import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
// import "../../../Assets/ptags/fonts/Montserrat-Black";
// import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
// import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
// import "../../../Assets/ptags/fonts/anton";

// export const generatePDF = (sectionsCount) => {



//     function getSelectPackageOptionValue(attributes) {
//         const selectPackageAttr = attributes?.find(attr => attr.name === "Select Package");

//         if (selectPackageAttr && selectPackageAttr.options && selectPackageAttr.options.length > 0) {
//           return selectPackageAttr.options[0].value;
//         }

//         return ""; // or undefined, or any default
//     }














//     const width = 1632;
//     const height = 1056;
//     const doc = new jsPDF({
//         orientation: "landscape",
//         unit: "pt",
//         format: [width, height],
//     });

//     const sectionWidth = width / 2;  // 1632 / 2 = 816 pt
//     const sectionHeight = height / 2; // 1056 / 2 = 528 pt


//     const bannerImgWidth = (width / 2) - 5;
//     const bannerImgHeight = 94;

//     const maxSectionsPerPage = 4; // 4 sections per page (2x2 grid per page)
//     let currentSection = 0;

//     // Loop through the sections and handle pages
//     while (currentSection < sectionsCount.length) {
//         // Add a new page if this isn't the first page
//         if (currentSection > 0) {
//             doc.addPage();
//         }

//         // Calculate number of sections on the current page
//         const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsCount.length - currentSection);

//         for (let i = 0; i < sectionsOnThisPage; i++) {
//             const sectionIndex = currentSection + i;
//             const xPos = (i % 2) * (width / 2) + 2.5;
//             const yPos = Math.floor(i / 2) * (height / 2) + 2.5;

//             if (sectionIndex < sectionsCount.length) {
//                 // Banner Image
//                 doc.addImage(banner1, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

//                 // Main Rectangle
//                 const sectionRectX = xPos + 2.5;
//                 const sectionRectY = yPos + bannerImgHeight + 4.8;
//                 const sectionRectWidth = sectionWidth / 2.9;
//                 const sectionRectHeight = sectionHeight - (bannerImgHeight + 12);





//                 doc.setLineWidth(2);
//                 doc.setDrawColor(71, 74, 119);



//                 const sectionMainImageX = xPos + sectionRectWidth + 2.5;
//                 const sectionMainImageWidth = sectionWidth - (sectionRectWidth + 2.5);
//                 const sectionMainImageHeight = 290;



//                 // // main product image
//                 // doc.addImage("https://fdapi.thefurnituredepots.com/uploads/media/Products/1739271656036_692_MSLS-Img-1.jpg", "JPEG", sectionMainImageX, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);

//                 const productImageUrl = Url+sectionsCount[sectionIndex]?.image?.image_url;
//                 const name = sectionsCount[sectionIndex]?.name;
//                 const sku ="Model#" + sectionsCount[sectionIndex]?.sku;
//                 const sale_price = sectionsCount[sectionIndex]?.sale_price;
//                 const regular_price = sectionsCount[sectionIndex]?.regular_price;

//                 if (productImageUrl) {
//                     doc.addImage(productImageUrl, "JPEG", sectionMainImageX, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);
//                 }

//                 // doc.addFont("Montserrat-ExtraBoldItalic-bolditalic.ttf", "Montserrat-ExtraBoldItalic-bolditalic", "bold");
//                 doc.setFont("Montserrat-Bold","bold");
//                 doc.setTextColor(0, 0, 0); // white text
//                 doc.setFontSize(14);
//                 // doc.setFont("helvetica", "bold");

//                 // Text position (adjust as needed)
//                 const textX = sectionMainImageX  + (sectionMainImageWidth-15);
//                 const textY = sectionRectY + 15;

//                 // Example text
//                 doc.text(name, textX, textY,{ align: 'right' });
//                 doc.setTextColor(0, 0, 0); // white text
//                 doc.setFontSize(16);
//                 doc.setFont("helvetica", "normal");
//                 doc.text(sku, textX, textY+20,{ align: 'right' });





//                 doc.rect(sectionRectX, sectionRectY, sectionRectWidth, sectionRectHeight, 'S');

//                 // Horizontal divider inside main rectangle
//                 const lineY = sectionRectY + sectionRectHeight / 4;
//                 doc.setLineWidth(2);
//                 doc.line(
//                     sectionRectX,
//                     lineY,
//                     sectionRectX + sectionRectWidth,
//                     lineY
//                 );


//                 const subSection1Width = sectionWidth / 2.9; // Assuming this is your sub-section width
//                 const wasPriceStartY = yPos;

//                 // Text for first line
//                 const text1 = getSelectPackageOptionValue(sectionsCount[sectionIndex]?.default_attributes);
//                 doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
//                 doc.setTextColor(40, 142, 169); // black text
//                 doc.setFontSize(11);
//                 const text1Width = doc.getTextWidth(text1);

//                 // Calculate the starting x position to center the text within the sub-section
//                 const wasPriceStartX1 = xPos + (subSection1Width - text1Width) / 2;
//                 doc.text(text1, wasPriceStartX1, wasPriceStartY + 120);

//                 // Text for second line
//                 const text2 = "$"+regular_price;
//                 doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
//                 doc.setTextColor(0, 0, 0); // black text
//                 doc.setFontSize(16);
//                 const text2Width = doc.getTextWidth(text2);

//                 // Calculate the starting x position to center the second text
//                 const wasPriceStartX2 = xPos + (subSection1Width - text2Width) / 2;
//                 doc.text(text2, wasPriceStartX2, wasPriceStartY + 140);

//                 // Text for third line
//                 const text3 = "$"+sale_price;
//                 doc.setFont("Montserrat-Black","normal");
//                 doc.setTextColor(253, 0, 0); // black text
//                 doc.setFontSize(50);
//                 const text3Width = doc.getTextWidth(text3);

//                 // Calculate the starting x position to center the third text
//                 const wasPriceStartX3 = xPos + (subSection1Width - text3Width) / 2;
//                 doc.text(text3, wasPriceStartX3, wasPriceStartY + 190);










// // === Left Rectangle with Grid ===
// const gridRectX = xPos + (sectionWidth / 1.49);
// const gridRectY = yPos + sectionHeight / 1.39 + 0.5;
// const gridRectW = sectionWidth / 3.1;
// const gridRectH = sectionHeight / 3.75;

// // Draw the left rectangle
// doc.setLineWidth(2);
// doc.rect(gridRectX, gridRectY, gridRectW, gridRectH, 'S');

// // Set up the positioning and line height
// const lineHeight = 15; // Adjust line height as needed
// const totalTextHeight = 4 * lineHeight; // Total height required for all lines
// const verticalOffset = (gridRectH - totalTextHeight) / 2; // Space above the first line to center text

// // === Line 1: "$34/week" with different styles ===
// const text1_main = "$"+(Math.ceil(parseFloat(sale_price)*0.026)).toString();
// const text1_suffix = "/week";



// // Set up text styles and measure their widths
// doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
// doc.setFontSize(34);
// const width_main = doc.getTextWidth(text1_main);

// doc.setFont("helvetica", "normal");
// doc.setFontSize(14);
// const width_suffix = doc.getTextWidth(text1_suffix);

// // Calculate total width of combined text
// const totalWidth = width_main + width_suffix + 2; // 2 is the space between "$34" and "/week"

// // Center position of the rectangle
// const textX_g1 = gridRectX + (gridRectW / 2);
// const textY_g1 = gridRectY + verticalOffset;

// // Calculate starting X so the combined text is centered
// const combinedTextX = textX_g1 - (totalWidth / 2);

// // Draw "$34"
// doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
// doc.setTextColor(253, 0, 0);
// doc.setFontSize(34);
// doc.text(text1_main, combinedTextX, textY_g1);

// // Draw "/week" after "$34"
// const suffixX = combinedTextX + width_main + 2;
// doc.setFont("helvetica", "bold");
// doc.setTextColor(61, 124, 157);
// doc.setFontSize(18);
// doc.text(text1_suffix, suffixX, textY_g1);


// // === Line 2: Different style ===
// const text2_g = "Subject to approval. some restrictions apply";
// doc.setFont("helvetica", "normal"); // Font for Line 2
// doc.setTextColor(151, 68, 131); // Blue color for Line 2
// doc.setFontSize(13); // Font size for Line 2
// const textY_g2 = gridRectY + verticalOffset + lineHeight +12; // Calculate Y position for Line 2
// doc.text(text2_g, textX_g1, textY_g2, { align: 'center' });

// // === Line 3: Different style ===
// const text3_g = "NO CREDIT 0 DOWN";
// doc.setFont("helvetica", "bold"); // Font for Line 3
// doc.setTextColor(136, 194, 87); // Red color for Line 3
// doc.setFontSize(24); // Font size for Line 3
// const textY_g3 = gridRectY + verticalOffset + (3.5 * lineHeight)+5 ; // Calculate Y position for Line 3
// doc.text(text3_g, textX_g1, textY_g3, { align: 'center' });

// // === Line 4: Different style ===
// const text4_g = "100 DAYS NO INTEREST";
// doc.setFont("helvetica", "bold"); // Font for Line 4
// doc.setTextColor(56, 112, 151); // Green color for Line 4
// doc.setFontSize(18); // Font size for Line 4
// const textY_g4 = gridRectY + verticalOffset + (5.5 * lineHeight)+5; // Calculate Y position for Line 4
// doc.text(text4_g, textX_g1, textY_g4, { align: 'center' });





//                 // Optional: another right rectangle (if still needed)
//                 const rightRectX = xPos + (sectionWidth / 2.83);
//                 const rightRectY = yPos + sectionHeight / 1.39 + 0.5;
//                 const rightRectW = sectionWidth / 3.2;
//                 const rightRectH = sectionHeight / 3.75;

//                 doc.setLineWidth(2);
//                 doc.rect(rightRectX, rightRectY, rightRectW, rightRectH, 'S');



//                 // Custom column widths (in percentage of total width)
//                 const col1 = rightRectW * 0.3;
//                 const col2 = rightRectW * 0.2;
//                 const col3 = rightRectW * 0.3;
//                 const col4 = rightRectW * 0.2;

//                 // Row height (still 4 rows)
//                 const rowHeight = rightRectH / 4;

//                 doc.setLineWidth(2);
//                 doc.setDrawColor(71, 74, 119); // Black

//                 // Draw 3 horizontal lines (4 rows)
//                 for (let r = 1; r < 4; r++) {
//                     const y = rightRectY + r * rowHeight;
//                     doc.line(rightRectX, y, rightRectX + rightRectW, y);
//                 }

//                 // Draw 3 vertical lines for custom-width columns
//                 const colX1 = rightRectX + col1;
//                 const colX2 = colX1 + col2;
//                 const colX3 = colX2 + col3;

//                 doc.line(colX1, rightRectY, colX1, rightRectY + rightRectH); // After col1
//                 doc.line(colX2, rightRectY, colX2, rightRectY + rightRectH); // After col2
//                 doc.line(colX3, rightRectY, colX3, rightRectY + rightRectH); // After col3












//             }
//         }


//         // Draw horizontal dashed line (same for every page)
//         doc.setLineDashPattern([10, 5], 0);
//         doc.setDrawColor(0); // black
//         doc.setLineWidth(1);
//         doc.line(0, height / 2, width, height / 2); // Horizontal line at half height

//         // Draw vertical dashed line (same for every page)
//         doc.line(width / 2, 0, width / 2, height); // Vertical line at half width

//         // Increment currentSection for the next page
//         currentSection += sectionsOnThisPage;
//     }

//     // Save the PDF
//     doc.save("dynamic-sections-with-lines.pdf");
// };





















import { jsPDF } from "jspdf";
import banner1 from "../../../Assets/ptags/banner.jpg";
import { Url,getAdjustedPrice } from "../../../Services/Api";

import "../../../Assets/ptags/fonts/Montserrat-Bold";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBold";
import "../../../Assets/ptags/fonts/Montserrat-Black";
import "../../../Assets/ptags/fonts/Montserrat-ExtraBoldItalic";
import "../../../Assets/ptags/fonts/Montserrat-BoldItalic";
import "../../../Assets/ptags/fonts/anton";

const now = new Date();
const timestamp = now
  .toISOString()           // e.g., "2025-08-15T21:45:30.123Z"
  .replace(/[:.]/g, '-')   // Replace colon and dot with dash
  .replace('T', '_')       // Replace 'T' with underscore
  .split('Z')[0];          // Remove trailing 'Z'



export const generatePDF = (sectionsCount, bannerImg) => {


    const width = 1632;
    const height = 1056;
    const doc = new jsPDF({
        orientation: "landscape",
        unit: "pt",
        format: [width, height],
    });

    const sectionWidth = width / 2;  // 1632 / 2 = 816 pt
    const sectionHeight = height / 2; // 1056 / 2 = 528 pt


    const bannerImgWidth = (width / 2) - 5;
    const bannerImgHeight = 94;

    const maxSectionsPerPage = 4; // 4 sections per page (2x2 grid per page)
    let currentSection = 0;

    // Loop through the sections and handle pages
    while (currentSection < sectionsCount.length) {
        // Add a new page if this isn't the first page
        if (currentSection > 0) {
            doc.addPage();
        }

        // Calculate number of sections on the current page
        const sectionsOnThisPage = Math.min(maxSectionsPerPage, sectionsCount.length - currentSection);

        for (let i = 0; i < sectionsOnThisPage; i++) {
            const sectionIndex = currentSection + i;
            const xPos = (i % 2) * (width / 2) + 2.5;
            const yPos = Math.floor(i / 2) * (height / 2) + 2.5;

            if (sectionIndex < sectionsCount.length) {
                // Banner Image
                doc.addImage(bannerImg, "JPEG", xPos, yPos, bannerImgWidth, bannerImgHeight);

                // Main Rectangle
                const sectionRectX = xPos + 2.5;
                const sectionRectY = yPos + bannerImgHeight + 4.8;
                const sectionRectWidth = sectionWidth / 2.9;
                const sectionRectHeight = sectionHeight - (bannerImgHeight + 12);





                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119);



                const sectionMainImageX = xPos + sectionRectWidth + 2.5;
                const sectionMainImageWidth = sectionWidth - (sectionRectWidth + 2.5);
                const sectionMainImageHeight = 290;



                // // main product image
                // doc.addImage("https://fdapi.thefurnituredepots.com/uploads/media/Products/1739271656036_692_MSLS-Img-1.jpg", "JPEG", sectionMainImageX, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);

                const productImageUrl = sectionsCount[sectionIndex]?.image;
                const name = sectionsCount[sectionIndex]?.name;
                const sku = "Model#" + sectionsCount[sectionIndex]?.sku;
                const sale_price = sectionsCount[sectionIndex]?.variations[0].sale_price;
                const regular_price = sectionsCount[sectionIndex]?.variations[0].regular_price;

                if (productImageUrl) {
                    doc.addImage(productImageUrl, "JPEG", sectionMainImageX, sectionRectY, sectionMainImageWidth, sectionMainImageHeight);
                }

                // doc.addFont("Montserrat-ExtraBoldItalic-bolditalic.ttf", "Montserrat-ExtraBoldItalic-bolditalic", "bold");
                doc.setFont("Montserrat-Bold", "bold");
                doc.setTextColor(0, 0, 0); // white text
                doc.setFontSize(14);
                // doc.setFont("helvetica", "bold");

                // Text position (adjust as needed)
                const textX = sectionMainImageX + (sectionMainImageWidth - 15);
                const textY = sectionRectY + 15;

                // Example text
                doc.text(name, textX, textY, { align: 'right' });
                doc.setTextColor(0, 0, 0); // white text
                doc.setFontSize(16);
                doc.setFont("helvetica", "normal");
                doc.text(sku, textX, textY + 20, { align: 'right' });





                doc.rect(sectionRectX, sectionRectY, sectionRectWidth, sectionRectHeight, 'S');

                // Horizontal divider inside main rectangle
                const lineY = sectionRectY + sectionRectHeight / 4;
                doc.setLineWidth(2);
                doc.line(
                    sectionRectX,
                    lineY,
                    sectionRectX + sectionRectWidth,
                    lineY
                );


                const subSection1Width = sectionWidth / 2.9; // Assuming this is your sub-section width
                const wasPriceStartY = yPos;

                // Text for first line
                const text1 = sectionsCount[sectionIndex]?.variations[0].value;
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setTextColor(40, 142, 169); // black text
                doc.setFontSize(11);
                const text1Width = doc.getTextWidth(text1);

                // Calculate the starting x position to center the text within the sub-section
                const wasPriceStartX1 = xPos + (subSection1Width - text1Width) / 2;
                doc.text(text1, wasPriceStartX1, wasPriceStartY + 120);

                // Text for second line
                const text2 = "was $" + regular_price;
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setTextColor(0, 0, 0); // black text
                doc.setFontSize(16);
                const text2Width = doc.getTextWidth(text2);

                // Calculate the starting x position to center the second text
                const wasPriceStartX2 = xPos + (subSection1Width - text2Width) / 2;
                doc.text(text2, wasPriceStartX2, wasPriceStartY + 140);

                // Text for third line
                const text3 = "$" + sale_price;
                doc.setFont("Montserrat-Black", "normal");
                doc.setTextColor(253, 0, 0); // black text
                doc.setFontSize(50);
                const text3Width = doc.getTextWidth(text3);

                // Calculate the starting x position to center the third text
                const wasPriceStartX3 = xPos + (subSection1Width - text3Width) / 2;
                doc.text(text3, wasPriceStartX3, wasPriceStartY + 190);



                if (sectionsCount[sectionIndex]?.variations.length > 1) {
                    // Print first variation separately (title)
                    doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                    doc.setTextColor(0, 0, 0); // black text
                    doc.setFontSize(11);
                    doc.text("Group Pricing", xPos + 10, lineY + 20);

                    // Loop through remaining variations
                    for (let index = 1; index < sectionsCount[sectionIndex].variations.length; index++) {
                        const variation = sectionsCount[sectionIndex].variations[index];
                        const yOffset = lineY + 20 + index * 20;

                        // Print value
                        doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                        doc.setTextColor(0, 0, 0); // black
                        doc.setFontSize(8);
                        doc.text(variation?.value || "N/A", xPos + 10, yOffset);

                        // Get the width of the value text to determine where the price should start
                        const valueWidth = doc.getTextWidth(variation?.value || "N/A");

                        // Print sale price right after value
                        doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                        doc.setTextColor(253, 0, 0);
                        doc.setFontSize(8);
                        doc.text(`$${variation?.sale_price || "0.00"}`, xPos + 10 + valueWidth + 5, yOffset); // 5 is the gap between value and price
                    }
                }














                // === Left Rectangle with Grid ===
                const gridRectX = xPos + (sectionWidth / 1.49);
                const gridRectY = yPos + sectionHeight / 1.39 + 0.5;
                const gridRectW = sectionWidth / 3.1;
                const gridRectH = sectionHeight / 3.75;

                // Draw the left rectangle
                doc.setLineWidth(2);
                doc.rect(gridRectX, gridRectY, gridRectW, gridRectH, 'S');

                // Set up the positioning and line height
                const lineHeight = 15; // Adjust line height as needed
                const totalTextHeight = 4 * lineHeight; // Total height required for all lines
                const verticalOffset = (gridRectH - totalTextHeight) / 2; // Space above the first line to center text

                // === Line 1: "$34/week" with different styles ===
                // const text1_main = "$" + (Math.ceil(parseFloat(sale_price) * 0.026)).toString();
                const text1_main = "$" + (getAdjustedPrice(sale_price)).toString();
                
                const text1_suffix = "/week";



                // Set up text styles and measure their widths
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setFontSize(34);
                const width_main = doc.getTextWidth(text1_main);

                doc.setFont("helvetica", "normal");
                doc.setFontSize(14);
                const width_suffix = doc.getTextWidth(text1_suffix);

                // Calculate total width of combined text
                const totalWidth = width_main + width_suffix + 2; // 2 is the space between "$34" and "/week"

                // Center position of the rectangle
                const textX_g1 = gridRectX + (gridRectW / 2);
                const textY_g1 = gridRectY + verticalOffset;

                // Calculate starting X so the combined text is centered
                const combinedTextX = textX_g1 - (totalWidth / 2);

                // Draw "$34"
                doc.setFont("Montserrat-ExtraBoldItalic", "bolditalic");
                doc.setTextColor(253, 0, 0);
                doc.setFontSize(34);
                doc.text(text1_main, combinedTextX, textY_g1);

                // Draw "/week" after "$34"
                const suffixX = combinedTextX + width_main + 2;
                doc.setFont("helvetica", "bold");
                doc.setTextColor(61, 124, 157);
                doc.setFontSize(18);
                doc.text(text1_suffix, suffixX, textY_g1);


                // === Line 2: Different style ===
                const text2_g = "Subject to approval. some restrictions apply";
                doc.setFont("helvetica", "normal"); // Font for Line 2
                doc.setTextColor(151, 68, 131); // Blue color for Line 2
                doc.setFontSize(13); // Font size for Line 2
                const textY_g2 = gridRectY + verticalOffset + lineHeight + 12; // Calculate Y position for Line 2
                doc.text(text2_g, textX_g1, textY_g2, { align: 'center' });

                // === Line 3: Different style ===
                const text3_g = "NO CREDIT 0 DOWN";
                doc.setFont("helvetica", "bold"); // Font for Line 3
                doc.setTextColor(136, 194, 87); // Red color for Line 3
                doc.setFontSize(24); // Font size for Line 3
                const textY_g3 = gridRectY + verticalOffset + (3.5 * lineHeight) + 5; // Calculate Y position for Line 3
                doc.text(text3_g, textX_g1, textY_g3, { align: 'center' });

                // === Line 4: Different style ===
                const text4_g = "100 DAYS NO INTEREST";
                doc.setFont("helvetica", "bold"); // Font for Line 4
                doc.setTextColor(56, 112, 151); // Green color for Line 4
                doc.setFontSize(18); // Font size for Line 4
                const textY_g4 = gridRectY + verticalOffset + (5.5 * lineHeight) + 5; // Calculate Y position for Line 4
                doc.text(text4_g, textX_g1, textY_g4, { align: 'center' });





                // Optional: another right rectangle (if still needed)
                const rightRectX = xPos + (sectionWidth / 2.83);
                const rightRectY = yPos + sectionHeight / 1.39 + 0.5;
                const rightRectW = sectionWidth / 3.2;
                const rightRectH = sectionHeight / 3.75;

                doc.setLineWidth(2);
                doc.rect(rightRectX, rightRectY, rightRectW, rightRectH, 'S');



                // Custom column widths (in percentage of total width)
                const col1 = rightRectW * 0.3;
                const col2 = rightRectW * 0.2;
                const col3 = rightRectW * 0.3;
                const col4 = rightRectW * 0.2;

                // Row height (still 4 rows)
                const rowHeight = rightRectH / 4;

                doc.setLineWidth(2);
                doc.setDrawColor(71, 74, 119); // Black

                // Draw 3 horizontal lines (4 rows)
                for (let r = 1; r < 5; r++) {
                    const y = rightRectY + r * rowHeight;
                    doc.line(rightRectX, y, rightRectX + rightRectW, y);
                }

                // Draw 3 vertical lines for custom-width columns
                const colX1 = rightRectX + col1;
                const colX2 = colX1 + col2;
                const colX3 = colX2 + col3;

                doc.line(colX1, rightRectY, colX1, rightRectY + rightRectH); // After col1
                doc.line(colX2, rightRectY, colX2, rightRectY + rightRectH); // After col2
                doc.line(colX3, rightRectY, colX3, rightRectY + rightRectH); // After col3


                const values = sectionsCount[sectionIndex]?.individuals;
                const maxItems = 8;
                const itemsPerRow = 2;
                const totalRows = Math.ceil(values.length / itemsPerRow); // auto-adjust rows if less than 8

                // Draw rows
                for (let r = 0; r < totalRows; r++) {
                    const y = rightRectY + (r + 1) * rowHeight;
                    doc.line(rightRectX, y, rightRectX + rightRectW, y);

                    const leftIndex = r * itemsPerRow;
                    const rightIndex = leftIndex + 1;

                    // Left Item
                    if (values[leftIndex]) {
                        const left = values[leftIndex];
                        const leftLabel =left.inputValue || "";
                        const leftSlug = left.p_price ? "$"+left.p_price : "";

                        const leftLabelX = rightRectX + col1 / 2 - 30;
                        const leftSlugX = rightRectX + col1 + col2 / 2 - 15;

                        const textY = y - rowHeight / 2 + 2;
                        doc.setFont("Montserrat-BoldItalic", "bolditalic");
                        doc.setTextColor(0, 0, 0); // black
                        doc.setFontSize(12);

                        doc.text(leftLabel, leftLabelX, textY, { align: 'left' });
                        doc.setTextColor(252, 0, 0);
                        doc.text(leftSlug, leftSlugX, textY, { align: 'left' });
                    }

                    // Right Item
                    if (values[rightIndex]) {
                        const right = values[rightIndex];
                        const rightLabel =right.inputValue || "";
                        const rightSlug =right.p_price ? "$"+right.p_price : "";

                        const rightLabelX = rightRectX + col1 + col2 + col3 / 2 - 30;
                        const rightSlugX = rightRectX + col1 + col2 + col3 + col4 / 2 - 15;

                        const textY = y - rowHeight / 2 + 2;
                        doc.setFont("Montserrat-BoldItalic", "bolditalic");
                        doc.setTextColor(0, 0, 0); // black
                        doc.setFontSize(12);

                        doc.text(rightLabel, rightLabelX, textY, { align: 'left' });
                        doc.setTextColor(252, 0, 0);
                        doc.text(rightSlug, rightSlugX, textY, { align: 'left' });
                    }
                }













            }
        }


        // Draw horizontal dashed line (same for every page)
        doc.setLineDashPattern([10, 5], 0);
        doc.setDrawColor(0); // black
        doc.setLineWidth(1);
        doc.line(0, height / 2, width, height / 2); // Horizontal line at half height

        // Draw vertical dashed line (same for every page)
        doc.line(width / 2, 0, width / 2, height); // Vertical line at half width

        // Increment currentSection for the next page
        currentSection += sectionsOnThisPage;
    }

    // Save the PDF
     doc.save(`price-tags_${timestamp}.pdf`);
};
